export default __webpack_public_path__ + "83078b9f6797953bf0e464a438313206.png";